import { Effect, Layer, Option, Schema } from "effect";
import { RecordingCompressionIo, recordingCompressionError } from "./service.ts";

const read = <A>(operation: () => A) => Effect.try({ try: operation, catch: recordingCompressionError });
const wait = <A>(operation: () => Promise<A>) => Effect.tryPromise({ try: operation, catch: recordingCompressionError });
const ChunkResult = Schema.Union([
  Schema.Struct({ done: Schema.Literal(true) }),
  Schema.Struct({ done: Schema.Literal(false), value: Schema.Uint8Array })
]);
export const RecordingCompressionIoLive = Layer.succeed(RecordingCompressionIo, RecordingCompressionIo.of({
  open: kind => read(() => kind === "gzip" ? new CompressionStream("gzip") : new DecompressionStream("gzip")),
  cancel: carrier => wait(() => carrier.readable.cancel()),
  writer: carrier => read(() => {
    const writer = carrier.writable.getWriter();
    return { write: bytes => wait(() => writer.write(bytes)), close: wait(() => writer.close()),
      abort: wait(() => writer.abort()), release: read(() => writer.releaseLock()) };
  }),
  reader: carrier => read(() => {
    const reader = carrier.readable.getReader();
    return { read: wait(() => reader.read()).pipe(Effect.flatMap(value => read(() => {
      const { done, value: bytes } = value;
      return { done, value: bytes };
    })), Effect.flatMap(value => read(() => Schema.decodeUnknownResult(ChunkResult)(value))),
    Effect.flatMap(value => Effect.fromResult(value).pipe(Effect.mapError(recordingCompressionError))),
    Effect.map(value => value.done ? Option.none() : Option.some(value.value))),
    cancel: wait(() => reader.cancel()), release: read(() => reader.releaseLock()) };
  })
}));
